<!-- 身份认证 -->
<template>
    <div class="auth">
        <template v-if="idAuth">
            <a-breadcrumb>
                <a-breadcrumb-item>DBG</a-breadcrumb-item>
                <a-breadcrumb-item>{{ $t('personal.personal_center') }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ $t('personal.identity_verification_page') }}</a-breadcrumb-item>
            </a-breadcrumb>
            <h1>{{ $t('personal.identity_verification_page') }}</h1>
            <div class="auth-body">
                <div class="_left">
                    <a-scrollbar class="card-scroll">
                        <div class="label" v-for="setting in setting" :key="setting.key">
                            <div class="_title-box">
                                <div class="flex align-center">
                                    <div class="img-box" v-if="setting.ifBind">
                                        <svg viewBox="0 0 1024 1024" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg"
                                             width="25" height="25">
                                            <path
                                                d="M431.8 708.8L206.3 483.4c-12.5-12.5-12.5-32.7 0-45.2s32.7-12.5 45.2 0l225.4 225.4c12.5 12.5 12.5 32.7 0 45.2-12.4 12.5-32.7 12.5-45.1 0z"
                                                fill="var(--content-white)">
                                            </path>
                                            <path
                                                d="M432.4 709.5c-12.6-12.6-12.6-33.2 0-45.8l337.3-337.3c12.6-12.6 33.2-12.6 45.8 0 12.6 12.6 12.6 33.2 0 45.8L478.2 709.5c-12.6 12.7-33.1 12.7-45.8 0z"
                                                fill="var(--content-white)">
                                            </path>
                                        </svg>
                                    </div>
                                    <div class="_row" @click="setting.openCard = !setting.openCard">
                                        <span>{{ setting.name }}</span>
                                        <a-tag class="tag"
                                               :color="setting.ifBind ? 'var(--content-trade-buy)' : 'var(--background-secondary)'">
                                        <span :class="setting.ifBind ? 'color-black' : 'color-white'">{{
                                                setting.status.name
                                            }}</span>
                                        </a-tag>
                                        <div class="down-box" :class="{'open-down': setting.openCard}">
                                            <icon-caret-down/>
                                        </div>
                                    </div>
                                </div>
                                <div class="button-container">
                                    <a-button class="button"
                                              v-if="setting.ifBind == false"
                                              :disabled="setting.key == 1 && (authStatus !== 1 && authStatus !== '1')"
                                              @click="goAuthentication(setting)">
                                        {{ setting.btn }}
                                    </a-button>
                                </div>
                            </div>
                            <div class="auth-info" :class="{'not-open': setting.openCard == false}">
                                <div class="cell">
                                    <span>{{ setting.des }}</span>
                                </div>
                                <template v-if="setting.openCard">
                                    <div class="cell">
                                        <span>{{ $t('personal.account_privileges') }}</span>
                                        <span>{{ $t('personal.current') }}</span>
                                    </div>
                                    <div class="cell">
                                        <span>{{ $t('personal.withdrawal') }}</span>
                                        <span>3M USDT</span>
                                    </div>
                                    <div class="cell">
                                        <span>{{ $t('personal.crypto_deposit') }}</span>
                                        <img src="@/assets/images/personal_img/allow.svg" alt="">
                                    </div>
                                    <div class="cell">
                                        <span>{{ $t('personal.fiat_deposit') }}</span>
                                        <img src="@/assets/images/personal_img/allow.svg" alt="">
                                    </div>
                                    <div class="cell">
                                        <span>{{ $t('personal.peer_to_peer_trading') }}</span>
                                        <img src="@/assets/images/personal_img/allow.svg" alt="">
                                    </div>
                                    <div class="cell">
                                        <span>{{ $t('personal.verification_requirements') }}</span>
                                    </div>
                                    <div class="cell">
                                    <span>
                                        <svg viewBox="0 0 1031 1024" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path
                                            d="M857.6 928 166.4 928c-89.6 0-166.4-70.4-166.4-166.4L0 262.4c0-89.6 70.4-166.4 166.4-166.4l697.6 0c89.6 0 166.4 70.4 166.4 166.4l0 505.6C1024 857.6 953.6 928 857.6 928zM166.4 160C108.8 160 64 204.8 64 262.4l0 505.6c0 57.6 44.8 102.4 102.4 102.4l697.6 0c57.6 0 102.4-44.8 102.4-102.4L966.4 262.4c0-57.6-44.8-102.4-102.4-102.4L166.4 160z"></path><path
                                            d="M364.8 576c-76.8 0-140.8-64-140.8-140.8 0-76.8 64-140.8 140.8-140.8s140.8 64 140.8 140.8C505.6 518.4 441.6 576 364.8 576zM364.8 358.4C320 358.4 281.6 396.8 281.6 435.2S320 512 364.8 512c44.8 0 76.8-32 76.8-76.8S403.2 358.4 364.8 358.4z"></path><path
                                            d="M576 742.4c-12.8 0-25.6-12.8-32-25.6C518.4 595.2 422.4 576 364.8 576S211.2 595.2 192 716.8c-6.4 19.2-19.2 25.6-38.4 25.6C134.4 736 121.6 723.2 128 704c25.6-115.2 115.2-192 236.8-192s217.6 70.4 236.8 192c6.4 19.2-6.4 32-25.6 38.4C576 742.4 576 742.4 576 742.4z"></path><path
                                            d="M864 448l-192 0C652.8 448 640 435.2 640 416S652.8 384 672 384l192 0C883.2 384 896 396.8 896 416S883.2 448 864 448z"></path><path
                                            d="M736 601.6l-64 0c-19.2 0-32-12.8-32-32s12.8-32 32-32l64 0c19.2 0 32 12.8 32 32S755.2 601.6 736 601.6z"></path></svg>
                                        {{ $t('personal.government_issued_documents') }}
                                    </span>
                                    </div>
                                    <div class="cell">
                                    <span>
                                        <svg viewBox="0 0 1024 1024" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg" p-id="25813" width="18" height="18"><path
                                            d="M319.95 362.61h63.99v85.32h-63.99v-85.32zM639.9 106.65h181.305c53.011 0 95.985 42.974 95.985 95.985V383.94h-64.033l0.043-181.305c0-16.63-12.689-30.298-28.914-31.849l-184.386-0.043V106.65z m-255.96 0v64.033l-181.305-0.043c-16.63 0-30.298 12.689-31.849 28.914l-0.043 184.386H106.65V202.635c0-53.011 42.974-95.985 95.985-95.985H383.94zM639.9 917.19v-64.033l181.305 0.043c16.63 0 30.298-12.689 31.849-28.914l0.043-184.386h64.093v181.305c0 53.011-42.974 95.985-95.985 95.985H639.9z m-255.96 0H202.635c-53.011 0-95.985-42.974-95.985-95.985V639.9h64.033l-0.043 181.305c0 16.63 12.689 30.298 28.914 31.849l184.386 0.043v64.093zM639.9 362.61h63.99v85.32H639.9v-85.32zM387.522 671.854l-26.621-17.748 35.495-53.243 26.622 17.748c20.889 13.926 50.34 21.289 88.902 21.289 38.561 0 68.013-7.363 88.902-21.289l26.622-17.748 35.495 53.243-26.621 17.748c-32.436 21.624-74.084 32.036-124.398 32.036-50.314 0-91.962-10.412-124.398-32.036z"></path></svg>
                                        {{ $t('personal.facial_recognition') }}
                                    </span>
                                    </div>
                                    <div class="cell">
                                    <span>
                                        <svg viewBox="0 0 1024 1024" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg" p-id="26835" width="18" height="18"><path
                                            d="M511.65 961C265.6 961 64.3 759.26 64.3 512.7S265.6 64.41 511.65 64.41 959 266.14 959 512.7 757.69 961 511.65 961zM656 856.61a377.28 377.28 0 0 0 198.65-199.12 371.82 371.82 0 0 0 0-289.58A377.18 377.18 0 0 0 656 168.79a369.15 369.15 0 0 0-288.64 0 377.09 377.09 0 0 0-198.71 199.12 371.82 371.82 0 0 0 0 289.58A377.12 377.12 0 0 0 367.33 856.6a369.21 369.21 0 0 0 288.64 0z"></path><path
                                            d="M473 555m0-37.5l0-249q0-37.5 37.5-37.5l0 0q37.5 0 37.5 37.5l0 249q0 37.5-37.5 37.5l0 0q-37.5 0-37.5-37.5Z"></path><path
                                            d="M796 554m-37.5 0l-249 0q-37.5 0-37.5-37.5l0 0q0-37.5 37.5-37.5l249 0q37.5 0 37.5 37.5l0 0q0 37.5-37.5 37.5Z"></path></svg>
                                        {{ $t('personal.estimated_review_time') }}
                                    </span>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </a-scrollbar>
                </div>
                <div class="_right">
                    <div class="card">
                        <div class="title">
                            <span>{{ $t('personal.personal_info') }}</span>
                            <div class="down-box" @click="infoShow = !infoShow">
                                <icon-caret-down/>
                            </div>
                        </div>
                        <template v-if="infoShow">
                            <div class="cell">
                                <span>{{ $t('personal.name') }}</span>
                                <span>{{ getDisplayValue(personalInfo.name) }}</span>
                            </div>
                            <div class="cell">
                                <span>{{ $t('personal.country') }}</span>
                                <span>{{ getDisplayValue(personalInfo.country) }}</span>
                            </div>
                            <div class="cell">
                                <span>{{ $t('personal.id_number') }}</span>
                                <span>{{ getDisplayValue(personalInfo.documentNumber) }}</span>
                            </div>
                        </template>
                    </div>
                    <div class="card">
                        <div class="title">
                            <span>{{ $t('personal.faq') }}</span>
                            <span>
                            {{ $t('personal.more') }}
                            <icon-right/>
                        </span>
                        </div>
                        <a-scrollbar class="faq-scroll">
                            <div class="cell-lb"
                                 :class="{'hideContent': item.openAll === false}"
                                 @click="item.openAll = !item.openAll"
                                 v-for="item in faqOptions">
                                <div class="_top">
                                    <span>{{ item.title }}</span>
                                    <icon-caret-down />
                                </div>
                                <div class="_content">
                                    <p>{{ item.desc }}</p>
                                    <p v-if="item.desc1">{{ item.desc1 }}</p>
                                </div>
                            </div>
                        </a-scrollbar>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="foundation">
            <foundationAuth @safet-event="goBack"></foundationAuth>
        </template>
        <template v-if="senior">
            <seniorAuth @safet-event="goBack"></seniorAuth>
        </template>
    </div>
    <div class="main-box" v-if="false">
        <div class="content-main-bottom">
            <div class="btm-left">
                <div class="btm-left-head">
                    <div class="user-management">
                        <div class=" user-management-header">
                        </div>
                        <div class="user-management-content">
                            <div class="title">
                                {{ $t('personal.identity_verification_page') }}
                            </div>
                            <div class="safe-setting" v-for="setting in setting" :key="setting.key">
                                <div class="box">
                                    <div class="flex">
                                        <img class="email"
                                             :src="require('@/assets/images/personal_img/management/' + setting.icon + '.png')"
                                             alt="">

                                        <div class="user-management-left">
                                            <div class="m-title">{{ setting.name }}</div>
                                            <div class="des">{{ setting.des }}</div>
                                        </div>
                                    </div>
                                    <div class="middle">
                                        <div class="point"
                                             v-if="setting.ifBind ? setting.status.color === '#ff9e2d' : setting.status.color === '#ff9e2d'"
                                             :style="{ backgroundColor: setting.status.color }"></div>
                                        <div class="cont">
                                            {{ setting.status.name }}
                                        </div>
                                    </div>
                                    <div>
                                        <a-button type="primary" size="large" @click="goAuthentication(setting)">
                                            {{ setting.btn }}
                                        </a-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- component start-->
    <div>

    </div>
    <!-- component end -->
</template>

<script>
import foundationAuth from '../foundationAuth/foundationAuth.vue'
import seniorAuth from '../seniorAuth/seniorAuth.vue'
import userApi from '@/common/api/user.js'
import country from '@/common/area.js'

export default {
    components: {
        foundationAuth,
        seniorAuth
    },
    data() {
        return {
            setting: [], // 初始化为空，在mounted中设置
            idAuth: true,
            foundation: false,
            senior: false,
            infoShow: true,
            faqOptions: [], // 初始化为空，在mounted中设置
            // 认证状态
            authStatus: null, // null=未认证, 0=审核中, 1=已通过, 2=已拒绝
            authInfo: null, // 认证信息
            isLoading: true, // 加载状态
            // 个人信息
            personalInfo: {
                name: '',
                country: '',
                documentNumber: ''
            }
        };
    },
    mounted() {
        this.initializeData();
            
            // 延迟获取认证状态，确保初始化完成
            this.$nextTick(() => {
                this.getAuthStatus();
                this.getPersonalInfo();
                
                // 强制刷新认证状态
                setTimeout(() => {
                    console.log('🔄 强制刷新认证状态...');
                    this.getAuthStatus();
                    this.getPersonalInfo();
                }, 1000);
            });
    },
    watch: {
        // 监听语言变化
        '$i18n.locale'() {
            this.initializeData();
            // 重新获取个人信息以更新国家名称的语言
            this.getPersonalInfo();
        }
    },
    methods: {
        // 初始化数据
        initializeData() {
            if (!this.$t) return; // 如果$t还没有准备好，直接返回
            
            this.setting = [
                {
                    name: this.$t('personal.level_one_basic_verification'),
                    des: this.$t('personal.basic_verification_fast'),
                    icon: 'idAuth',
                    status: {
                        name: this.$t('personal.not_verified'),
                        color: '#ff9e2d'
                    },
                    btn: this.$t('personal.go_verify'),
                    type: 'primary',
                    ifBind: false,
                    key: 0,
                    openCard: false
                },
                {
                    name: this.$t('personal.level_two_advanced_verification'),
                    des: this.$t('personal.advanced_verification_benefits'),
                    icon: 'idAuth',
                    status: {
                        name: this.$t('personal.not_verified'),
                        color: '#666'
                    },
                    btn: this.$t('personal.go_verify'),
                    type: 'primary',
                    ifBind: false,
                    key: 1,
                    openCard: false
                }
            ];
            
            this.faqOptions = [{
                title: this.$t('personal.why_identity_verification'),
                desc: this.$t('personal.identity_verification_desc'),
                openAll: false
            }, {
                title: this.$t('personal.what_countries_not_supported'),
                desc: this.$t('personal.unsupported_countries_desc'),
                openAll: false
            }, {
                title: this.$t('personal.what_documents_for_verification'),
                desc: this.$t('personal.level_one_supported_documents'),
                desc1: this.$t('personal.level_two_supported_documents'),
                openAll: false
            }, {
                title: this.$t('personal.identity_verification_restrictions'),
                desc: this.$t('personal.age_restriction'),
                desc1: this.$t('personal.account_restriction'),
                openAll: false
            }];
        },
        goAuthentication(e) {
            console.log('点击认证按钮:', e);
            
            if (e.key == 0) {
                // 基础认证
                if (this.authStatus === 2 || this.authStatus === '2') {
                    // 已拒绝状态，显示提示
                    this.$message.info(this.$t('personal.please_resubmit_verification'));
                }
                
                console.log('进入基础认证页面');
                this.foundation = true;
                this.idAuth = false;
                this.senior = false;
            } else if (e.key == 1) {
                // 高级认证 - 需要先通过基础认证
                if (this.authStatus !== 1 && this.authStatus !== '1') {
                    // 基础认证未通过，显示提示
                    this.$message.warning(this.$t('personal.please_complete_basic_verification_first'));
                    return;
                }
                
                console.log('进入高级认证页面');
                this.foundation = false;
                this.idAuth = false;
                this.senior = true;
            }
        },
        goBack() {
            this.foundation = false;
            this.senior = false;
            this.idAuth = true;
            
            // 重新获取认证状态
            this.getAuthStatus();
            this.getPersonalInfo();
        },
        
        // 获取个人信息
        async getPersonalInfo() {
            try {
                console.log('🔍 获取个人信息...');
                const response = await userApi.baseAuthInfo();
                
                if (response && response.code === 200 && (response.data.data || response.data)) {
                    const data = response.data.data || response.data;
                    
                    // 处理姓名：surname + name
                    const fullName = data.surname && data.name ? 
                        `${data.surname} ${data.name}` : 
                        (data.surname || data.name || '');
                    
                    // 处理证件号码：隐藏中间部分
                    let documentNumber = '';
                    if (data.no) {
                        if (data.no.length > 8) {
                            documentNumber = data.no.substring(0, 4) + '****' + data.no.substring(data.no.length - 4);
                        } else {
                            documentNumber = data.no;
                        }
                    }
                    
                    // 处理国家代码
                    let countryName = '';
                    // 优先使用国家代码字段（country_code, countryCode, country）
                    // 如果这些字段不存在，再使用 code 字段
                    const countryCode = data.country_code || data.countryCode || data.country || data.code;
                    
                    console.log('🔍 国家信息处理:', {
                        country_code: data.country_code,
                        countryCode: data.countryCode,
                        country: data.country,
                        code: data.code,
                        finalCountryCode: countryCode
                    });
                    
                    if (countryCode) {
                        // 如果 countryCode 是区号（以 + 开头），需要特殊处理
                        if (countryCode.startsWith('+')) {
                            // 区号匹配：+1 对应多个国家，优先返回美国
                            console.log('🔍 检测到区号格式，使用区号匹配:', countryCode);
                            const countryInfo = this.getCountryByDialingCode(countryCode);
                            if (countryInfo) {
                                countryName = this.$i18n.locale === 'zh_CN' ? countryInfo.cnName : countryInfo.enName;
                                console.log('✅ 通过区号找到国家:', countryName, countryInfo.code);
                            } else {
                                countryName = countryCode; // 如果找不到对应的国家，显示原始代码
                                console.log('⚠️ 未找到匹配的国家，使用原始代码:', countryCode);
                            }
                        } else {
                            // 国家代码匹配（如 "us", "ca"）
                            console.log('🔍 检测到国家代码格式，使用国家代码匹配:', countryCode);
                            const countryInfo = this.getCountryByCode(countryCode);
                            if (countryInfo) {
                                // 根据当前语言显示对应的国家名称
                                countryName = this.$i18n.locale === 'zh_CN' ? countryInfo.cnName : countryInfo.enName;
                                console.log('✅ 通过国家代码找到国家:', countryName, countryInfo.code);
                            } else {
                                countryName = countryCode; // 如果找不到对应的国家，显示原始代码
                                console.log('⚠️ 未找到匹配的国家，使用原始代码:', countryCode);
                            }
                        }
                    }
                    
                    this.personalInfo = {
                        name: fullName,
                        country: countryName,
                        documentNumber: documentNumber
                    };
                    
                    console.log('✅ 个人信息获取成功:', this.personalInfo);
                } else {
                    console.log('ℹ️ 未找到个人信息');
                    this.personalInfo = {
                        name: '',
                        country: '',
                        documentNumber: ''
                    };
                }
            } catch (error) {
                console.error('❌ 获取个人信息失败:', error);
                this.personalInfo = {
                    name: '',
                    country: '',
                    documentNumber: ''
                };
            }
        },
        
        // 根据国家代码获取国家信息（优先匹配国家代码，如 "us", "ca"）
        getCountryByCode(code) {
            if (!code) return null;
            
            // 优先匹配国家代码（code 字段）
            let countryInfo = country.countryList.find(item => item.code === code);
            if (countryInfo) return countryInfo;
            
            // 如果国家代码不匹配，尝试匹配英文名称
            countryInfo = country.countryList.find(item => item.enName === code || item.enName.toUpperCase() === code.toUpperCase());
            if (countryInfo) return countryInfo;
            
            // 尝试匹配中文名称
            countryInfo = country.countryList.find(item => item.cnName === code);
            if (countryInfo) return countryInfo;
            
            return null;
        },
        
        // 根据区号获取国家信息（用于处理 +1 这种区号）
        getCountryByDialingCode(dialingCode) {
            if (!dialingCode) return null;
            
            // 查找匹配区号的国家
            const countries = country.countryList.filter(item => item.dialingCode === dialingCode);
            
            // 如果只有一个国家使用该区号，直接返回
            if (countries.length === 1) {
                return countries[0];
            }
            
            // 如果多个国家使用同一区号（如 +1 对应美国和加拿大），优先返回美国（us）
            if (countries.length > 1) {
                // 优先返回美国
                const usCountry = countries.find(item => item.code === 'us');
                if (usCountry) return usCountry;
                // 如果没有美国，返回第一个
                return countries[0];
            }
            
            return null;
        },
        
        // 获取显示值
        getDisplayValue(value) {
            // 如果值为空或未认证，显示星号
            if (!value || value.trim() === '') {
                return '***********';
            }
            return value;
        },
        async getAuthStatus() {
            try {
                console.log('🔍 获取认证状态...');
                const response = await userApi.baseAuthInfo();
                
                console.log('🔍 API响应:', response);
                console.log('🔍 响应类型:', typeof response);
                console.log('🔍 响应结构:', Object.keys(response || {}));
                
                if (response && (response.code === 200 || response.success === true)) {
                    // 获取认证数据 - 优先使用 response.data.data，如果没有则使用 response.data
                    const authData = response.data.data || response.data;
                    this.authInfo = authData;
                    
                    // 详细检查 status 字段
                    console.log('🔍 详细检查 status 字段:');
                    console.log('response.data:', response.data);
                    console.log('response.data.data:', response.data.data);
                    console.log('authData:', authData);
                    console.log('authData.status:', authData?.status);
                    console.log('authData.status 类型:', typeof authData?.status);
                    console.log('authData.status === 0:', authData?.status === 0);
                    console.log('authData.status === "0":', authData?.status === "0");
                    
                    this.authStatus = authData?.status;
                    
                    console.log('✅ 认证状态获取成功:', {
                        status: this.authStatus,
                        info: this.authInfo,
                        statusType: typeof this.authStatus,
                        dataKeys: Object.keys(response.data || {})
                    });
                    
                    // 更新认证状态显示
                    this.updateAuthStatus();
                } else {
                    console.log('ℹ️ 未找到认证信息，可能是首次认证');
                    console.log('🔍 响应条件检查:', {
                        hasResponse: !!response,
                        code: response?.code,
                        success: response?.success
                    });
                    this.authStatus = null;
                    this.authInfo = null;
                    // 重置为默认状态
                    this.initializeData();
                }
            } catch (error) {
                console.error('❌ 获取认证状态失败:', error);
                this.authStatus = null;
                this.authInfo = null;
                // 重置为默认状态
                this.initializeData();
            } finally {
                this.isLoading = false;
            }
        },
        updateAuthStatus() {
            console.log('🔍 开始更新认证状态显示...');
            console.log('🔍 当前认证状态:', this.authStatus);
            console.log('🔍 当前设置:', this.setting[0]);
            
            // 根据认证状态更新显示
            if (this.authStatus !== null && this.authStatus !== undefined) {
                console.log('🔍 处理认证状态:', this.authStatus, '类型:', typeof this.authStatus);
                
                // 基础认证状态更新
                if (this.authStatus === 0 || this.authStatus === '0') {
                    // 待审核 - 已提交，等待审核
                    this.setting[0].status = {
                        name: this.$t('personal.verification_pending'),
                        color: '#ff9e2d'
                    };
                    this.setting[0].btn = this.$t('personal.view_status');
                    this.setting[0].ifBind = true; // 已绑定，不显示"去认证"按钮
                    console.log('✅ 设置为待审核状态');
                } else if (this.authStatus === 1 || this.authStatus === '1') {
                    // 已通过
                    this.setting[0].status = {
                        name: this.$t('personal.verification_approved'),
                        color: '#52c41a'
                    };
                    this.setting[0].btn = this.$t('personal.view_details');
                    this.setting[0].ifBind = true; // 已绑定，不显示"去认证"按钮
                    console.log('✅ 设置为已通过状态');
                } else if (this.authStatus === 2 || this.authStatus === '2') {
                    // 已拒绝
                    this.setting[0].status = {
                        name: this.$t('personal.verification_rejected'),
                        color: '#ff4d4f'
                    };
                    this.setting[0].btn = this.$t('personal.resubmit');
                    this.setting[0].ifBind = false; // 未绑定，显示"重新提交"按钮
                    console.log('✅ 设置为已拒绝状态');
                } else {
                    console.log('⚠️ 未知的认证状态:', this.authStatus, '类型:', typeof this.authStatus);
                }
                
                console.log('✅ 认证状态已更新:', {
                    status: this.authStatus,
                    setting: this.setting[0]
                });
                
                // 强制更新视图
                this.$forceUpdate();
            } else {
                console.log('ℹ️ 认证状态为null，保持默认状态');
            }
            
            // 处理高级认证状态
            this.updateAdvancedAuthStatus();
        },
        async updateAdvancedAuthStatus() {
            try {
                console.log('🔍 获取高级认证状态...');
                const response = await userApi.advancedAuthInfo();
                
                if (response && response.code === 200) {
                    // 详细调试API响应
                    console.log('🔍 完整API响应:', response);
                    console.log('🔍 response.data:', response.data);
                    console.log('🔍 response.data.data:', response.data.data);
                    
                    // 获取认证数据 - 优先使用 response.data.data，如果没有则使用 response.data
                    const authData = response.data.data || response.data;
                    console.log('🔍 认证数据:', authData);
                    console.log('🔍 authData.video_status:', authData?.video_status);
                    console.log('🔍 authData.video_status 类型:', typeof authData?.video_status);
                    console.log('🔍 authData.hstatus:', authData?.hstatus);
                    console.log('🔍 authData.hstatus 类型:', typeof authData?.hstatus);
                    console.log('🔍 authData.status:', authData?.status);
                    console.log('🔍 authData.status 类型:', typeof authData?.status);
                    
                    // 详细检查所有可能的字段
                    console.log('🔍 所有认证相关字段:');
                    Object.keys(authData || {}).forEach(key => {
                        if (key.includes('status') || key.includes('auth') || key.includes('verify')) {
                            console.log(`  ${key}:`, authData[key], '类型:', typeof authData[key]);
                        }
                    });
                    
                    // 使用hstatus字段作为高级认证状态
                    // 只有当hstatus有明确值时才使用，否则表示未认证
                    let advancedStatus;
                    if (authData?.hstatus !== null && authData?.hstatus !== undefined && authData?.hstatus !== "") {
                        advancedStatus = authData.hstatus;
                    } else if (authData?.video_status !== null && authData?.video_status !== undefined && authData?.video_status !== "") {
                        advancedStatus = authData.video_status;
                    } else {
                        // 如果hstatus和video_status都是空值，则表示未认证
                        advancedStatus = null;
                    }
                    console.log('🔍 最终使用的高级认证状态:', advancedStatus);
                    console.log('🔍 状态类型:', typeof advancedStatus);
                    console.log('🔍 状态比较测试:');
                    console.log('  advancedStatus === 0:', advancedStatus === 0);
                    console.log('  advancedStatus === "0":', advancedStatus === "0");
                    console.log('  advancedStatus == 0:', advancedStatus == 0);
                    console.log('  advancedStatus === null:', advancedStatus === null);
                    console.log('  advancedStatus === undefined:', advancedStatus === undefined);
                    console.log('  advancedStatus === "":', advancedStatus === "");
                    console.log('  advancedStatus === "null":', advancedStatus === "null");
                    console.log('  advancedStatus === "undefined":', advancedStatus === "undefined");
                    console.log('  advancedStatus === false:', advancedStatus === false);
                    console.log('  advancedStatus === 0:', advancedStatus === 0);
                    console.log('  advancedStatus === "0":', advancedStatus === "0");
                    console.log('  advancedStatus === 1:', advancedStatus === 1);
                    console.log('  advancedStatus === "1":', advancedStatus === "1");
                    console.log('  advancedStatus === 2:', advancedStatus === 2);
                    console.log('  advancedStatus === "2":', advancedStatus === "2");
                    
                    // 高级认证状态更新
                    console.log('🔍 开始状态判断...');
                    
                    // 首先检查是否为未认证状态（空值、null、undefined、空字符串、false等）
                    if (advancedStatus === null || advancedStatus === undefined || advancedStatus === "" || 
                        advancedStatus === "null" || advancedStatus === "undefined" || advancedStatus === false ||
                        (typeof advancedStatus === 'string' && advancedStatus.trim() === '')) {
                        // 未认证
                        console.log('✅ 匹配到未认证状态 (空值/null/undefined)');
                        this.setting[1].status = {
                            name: this.$t('personal.not_verified'),
                            color: '#666'
                        };
                        this.setting[1].btn = this.$t('personal.go_verify');
                        this.setting[1].ifBind = false;
                        console.log('✅ 高级认证设置为未认证状态');
                    } else if (advancedStatus === 0 || advancedStatus === '0') {
                        // 待审核
                        console.log('✅ 匹配到待审核状态 (0)');
                        this.setting[1].status = {
                            name: this.$t('personal.verification_pending'),
                            color: '#ff9e2d'
                        };
                        this.setting[1].btn = this.$t('personal.view_status');
                        this.setting[1].ifBind = true;
                        console.log('✅ 高级认证设置为待审核状态');
                    } else if (advancedStatus === 1 || advancedStatus === '1') {
                        // 已通过
                        console.log('✅ 匹配到已通过状态 (1)');
                        this.setting[1].status = {
                            name: this.$t('personal.verification_approved'),
                            color: '#52c41a'
                        };
                        this.setting[1].btn = this.$t('personal.view_details');
                        this.setting[1].ifBind = true;
                        console.log('✅ 高级认证设置为已通过状态');
                    } else if (advancedStatus === 2 || advancedStatus === '2') {
                        // 已拒绝
                        console.log('✅ 匹配到已拒绝状态 (2)');
                        this.setting[1].status = {
                            name: this.$t('personal.verification_rejected'),
                            color: '#ff4d4f'
                        };
                        this.setting[1].btn = this.$t('personal.resubmit');
                        this.setting[1].ifBind = false;
                        console.log('✅ 高级认证设置为已拒绝状态');
                    } else {
                        // 其他未知状态，也设置为未认证
                        console.log('⚠️ 未匹配到任何已知状态，设置为未认证状态');
                        console.log('⚠️ 当前状态值:', advancedStatus, '类型:', typeof advancedStatus);
                        this.setting[1].status = {
                            name: this.$t('personal.not_verified'),
                            color: '#666'
                        };
                        this.setting[1].btn = this.$t('personal.go_verify');
                        this.setting[1].ifBind = false;
                        console.log('✅ 高级认证设置为未认证状态');
                    }
                    
                    // 强制更新视图
                    this.$forceUpdate();
                } else {
                    console.log('ℹ️ 高级认证未找到信息，保持默认状态');
                }
            } catch (error) {
                console.error('❌ 获取高级认证状态失败:', error);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./isAuth.scss";
</style>
  